import { render } from "./App.vue?vue&type=template&id=2c3ce81c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nori/Dropbox (Nakajima Glass)/ngciio/ngci-members/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__